import { useGetAllCampaignsApiV1Suspense } from "@/api/__generated__/api.schema";
import { CampaignCard } from "@/components/shared/campaign-card";
import { CAMPAIGN_INFO } from "@/constants/campaign";
import { routes } from "@/constants/url";
import { useWorkspaceId } from "@/hooks/auth/use-workspace";
import { useWorkspaceNavigate } from "@/lib/router/use-workspace-navigate";
import { WorkspaceLink } from "@/lib/router/workspace-link";
import { Typography } from "@backpac/monica";
import { useEffect } from "react";
import { Temporal } from "temporal-polyfill";

export function HomePage() {
  const navigate = useWorkspaceNavigate();

  // redirect to payout page
  // NOTE: Didn't care about whether user is over admin or not
  useEffect(() => {
    navigate(routes.PAYOUT.root, { replace: true });
  }, [navigate]);

  return null;
}

export function OngoingCampaigns() {
  const workspaceId = useWorkspaceId();
  const {
    data: {
      data: { items: campaigns },
    },
  } = useGetAllCampaignsApiV1Suspense(workspaceId);

  return (
    <section>
      <Typography asChild font="unbounded" size="lg" weight={400} className="mb-4">
        <h2>Ongoing Cmapaigns</h2>
      </Typography>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        {campaigns
          .filter((campaign) => CAMPAIGN_INFO[campaign.id] != null)
          .map((campaign) => (
            <WorkspaceLink key={campaign.id} to={routes.CAMPAIGNS._detail(campaign.id)}>
              <CampaignCard
                campaignTitle={campaign.title}
                materialTitle={`${campaign.artistName} - ${campaign.trackName}`}
                dateRange={[
                  Temporal.PlainDateTime.from(campaign.campaignSignUpStartDate),
                  Temporal.PlainDateTime.from(campaign.campaignSignUpEndDate),
                ]}
                status={campaign.campaignStatus}
                thumbnail={CAMPAIGN_INFO[campaign.id]?.material.cover}
              />
            </WorkspaceLink>
          ))}
      </div>
    </section>
  );
}
